/**
 * Single template
 * This file contains logic specific to a template.
 * It is intended to ONLY be loaded on templates that require
 * this specific functionality.
 **/

import Global from './lib/global';
import Logger from './lib/logger';

// Vars
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

const NAME = 'Single';

// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

/**
 * init - Initialize the page
 **/
const init = () => {
	Logger.log(`${NAME} > loaded`);
	initShareButton();
}

/**
 * initShareButton
 */
const initShareButton = () => {
	Logger.log(`${NAME} > initShareButton`);
	const shareButton = document.querySelector('[data-share-button]');
	if (!shareButton) return;
	shareButton.addEventListener('click', () => {
		const url = window.location.href;
		navigator.clipboard.writeText(url);

		// Change button text and then change it back
		const duration = 4000;
		const originalText = shareButton.textContent;
		shareButton.textContent = 'Copied!';
		setTimeout(() => {
			shareButton.textContent = originalText;
		}, duration);

		// Show toast
		showToast('Link copied!', duration);
	});
}

/**
 * showToast
 */
const showToast = (message, duration) => {
	Logger.log(`${NAME} > showToast`);
	window.dispatchEvent(new CustomEvent('toast:show', { detail: { msg: message, duration: duration } }));
}

// Bootstrap global functionality
Global();

// Bootstrap page-specific functionality
init();

// Do not edit below this line...
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
Logger.log(`${NAME} > loaded`);
